
import LoyaltyCampaignsService from '../../../services/loyalty/campaigns'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createCampaign ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      LoyaltyCampaignsService.createCampaign(payload).then(response => { 
        if (response.data && response.data.data._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating campaign'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCampaigns ({ commit },params) {

    return new Promise((resolve, reject) => { 
        LoyaltyCampaignsService.getCampaigns(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
    getCampaign ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      LoyaltyCampaignsService.getCampaign(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  deleteCampaign ({ commit }, id) {

    return new Promise((resolve, reject) => { 
      LoyaltyCampaignsService.deleteCampaign(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateCampaign ({ commit }, campaign) {

    return new Promise((resolve, reject) => { 
      LoyaltyCampaignsService.updateCampaign(campaign).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
}